module.exports = __webpack_public_path__ + "img/logo白.5f5a5cce.png";